// extracted by mini-css-extract-plugin
export default {"bottom":"BottomBar_bottom__mTbmM","right":"BottomBar_right__uZALI","left":"BottomBar_left__CCR0o","bottom_icons":"BottomBar_bottom_icons__kqhqE"};